"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LocaleFormatter = void 0;
const ignoredParts = new Set(['decimal', 'fraction']);
const signParts = new Set(['currency', 'literal']);
class LocaleFormatter {
    constructor(locale, currency) {
        this.locale = locale;
        this.currency = currency;
        this.toCurrencyParts = (amount, showFractionDigits) => {
            const parts = this.currencyFormatter.formatToParts(amount);
            return parts.filter(({ type }) => showFractionDigits || !ignoredParts.has(type));
        };
        this.join = (parts) => parts
            .map((x) => x.value)
            .join('')
            .replace(/\s+/g, ' ');
        this.formatCurrency = (amount, showFractionDigits = false) => this.join(this.toCurrencyParts(amount, showFractionDigits));
        this.formatCurrencyToObject = (amount, showFractionDigits = false) => {
            const parts = this.toCurrencyParts(amount, showFractionDigits);
            const currencySign = this.join(parts.filter(({ type }) => signParts.has(type)));
            const formattedAmount = this.join(parts.filter(({ type }) => !signParts.has(type)));
            const currencySignPosition = parts[0].type === 'currency' ? 'before' : 'after';
            return {
                formattedAmount,
                currencySign,
                currencySignPosition,
            };
        };
        try {
            this.currencyFormatter = new Intl.NumberFormat(locale, {
                style: 'currency',
                currency,
            });
        }
        catch (e) {
            this.currencyFormatter = new Intl.NumberFormat('en', {
                style: 'currency',
                currency: 'GBP',
            });
        }
    }
}
exports.LocaleFormatter = LocaleFormatter;
//# sourceMappingURL=index.js.map